/*
  Tagesnotizen der Planung (TimetableDayComment), je Datum für die Tageszeile
  des Rasters. In der Mitarbeitenden-Ansicht nur mit Zusatzmodul
  employee_day_comments und ohne Bearbeitung.
*/

export function groupDayCommentsByDate(dayComments) {
  return (Array.isArray(dayComments) ? dayComments : []).reduce((accumulator, dayComment) => {
    accumulator[dayComment.dateKey] = dayComment.comment;
    return accumulator;
  }, {});
}
